import React from "react";
import BorderColorRoundedIcon from "@material-ui/icons/BorderColor";
function Header() {
  return (
    <header>
      <h1>
        <BorderColorRoundedIcon /> Keeper App
      </h1>
    </header>
  );
}

export default Header;
